/**
 * menuTop要吃的設定
 * 設定menu
 *
 * 第一個nav menu 第一層可使用 icon
 * 第二個nav submenu 可以用 icon
 * editshow: true 為編輯才顯示
 *
 */

const systemMenu = {
    association: [{
        title: {
            CH: "系統管理",
        },
        name: "association_system",
        children: [{
            title: {
                CH: "使用者管理",
            },
            name: "admin",
            submenu: [{
                title: {
                    CH: "返回使用者管理",
                },
                name: "admin",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "admin_edit",
            },
            {
                title: {
                    CH: "角色設定",
                },
                name: "admin_role",
                editshow: true,
            },
            // {
            //     title: { CH: '權限設定' },
            //     name: 'admin_permission',
            //     editshow: true
            // },
            {
                title: {
                    CH: "登入紀錄",
                },
                name: "admin_loginlog",
                icon: "fa-history",
                editshow: true,
            },
            ],
        },
        // {
        //     title: { CH: '區會員工管理' },
        //     name: '',
        // }, {
        //     title: { CH: '協會員工管理' },
        //     name: '',
        // },
        {
            title: {
                CH: "權限管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "權限項目管理",
                },
                name: "permission",
            },
            {
                title: {
                    CH: "選單管理",
                },
                name: "web_menu",
            },
            {
                title: {
                    CH: "角色管理",
                },
                name: "role",
            },
            {
                title: {
                    CH: "協會業務設定",
                },
                name: "associ_business",
            },
            {
                title: {
                    CH: "儲互社業務設定",
                },
                name: "coop_business",
            },
            {
                title: {
                    CH: "儲互社審查作業設定",
                },
                name: "review",
            },
            ],
        },
        {
            title: {
                CH: "通用設定",
            },
            name: "",
            icon: "fa-cog",
            children: [{
                title: {
                    CH: "全域參數設定",
                },
                name: "global_parameter",
            },
            {
                title: {
                    CH: "歷年全國平均股息率",
                },
                name: "average_dividend",
            },
            {
                title: {
                    CH: "專案放款設定",
                },
                name: "project_loan",
                submenu: [{
                    title: {
                        CH: "返回專案放款設定",
                    },
                    name: "project_loan",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "project_loan_edit",
                },
                {
                    title: {
                        CH: "報表欄位設定",
                    },
                    name: "project_loan_report",
                    editshow: true,
                },
                {
                    title: {
                        CH: "申請件管理",
                    },
                    name: "project_loan_application",
                    editshow: true,
                    submenu: [{
                        title: {
                            CH: "返回申請件管理",
                        },
                        name: "project_loan_application",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "基本資料",
                        },
                        name: "project_loan_edit",
                    },
                    {
                        title: {
                            CH: "報表欄位設定",
                        },
                        name: "project_loan_report",
                        editshow: true,
                    },
                    {
                        title: {
                            CH: "申請件管理",
                        },
                        name: "project_loan_application",
                        editshow: true,
                    },
                    ],
                },
                ],
            },
            {
                title: {
                    CH: "會計科目管理",
                },
                name: "accounting",
            },
            {
                title: {
                    CH: "放款資產明細評估提撥比例設定",
                },
                name: "gen_loan_asset_rate",
            },
            {
                title: {
                    CH: "職稱管理",
                },
                name: "job_title",
            },
            {
                title: {
                    CH: "利害關係人名稱管理",
                },
                name: "interested_parties",
            },
            {
                title: {
                    CH: "族別管理",
                },
                name: "indigenous",
            },
            {
                title: {
                    CH: "職業管理",
                },
                name: "job",
            },
            {
                title: {
                    CH: "法催工作管理",
                },
                name: "prompt",
            },
            {
                title: {
                    CH: "還款寬限例外設定",
                },
                name: "loan_break_exception",
            },
            {
                title: {
                    CH: "借款用途管理",
                },
                name: "loan_purpose",
            },
            {
                title: {
                    CH: "區會管理",
                },
                name: "area",
            },
            {
                title: {
                    CH: "縣市區域管理",
                },
                name: "country",
            },
            {
                title: {
                    CH: "系統排程設定",
                },
                name: "system_scheduling",
            },
            // 0119 sa 說先隱藏
            // {
            //     title: {
            //         CH: "一般報表設定",
            //     },
            //     name: "report_setting",
            // },
            {
                title: {
                    CH: "退社原因設定",
                },
                name: "exit_reason",
            },
            ],
        },
        //
        {
            title: {
                CH: "儲互社管理",
            },
            name: "associattion_coop",
            submenu: [{
                title: {
                    CH: "返回儲互社管理",
                },
                name: "associattion_coop",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "associattion_coop_edit",
            },
            {
                title: {
                    CH: "營業時間",
                },
                name: "associattion_coop_time",
                editshow: true,
            },
            {
                title: {
                    CH: "人員管理",
                },
                name: "associattion_coop_member",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回人員管理",
                    },
                    name: "associattion_coop_member",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "associattion_coop_member_edit",
                },
                {
                    title: {
                        CH: "角色設定",
                    },
                    name: "associattion_coop_member_role",
                    editshow: true,
                },
                // {
                //     title: { CH: '權限設定' },
                //     name: 'associattion_coop_member_permission',
                //     editshow: true
                // },
                {
                    title: {
                        CH: "登入紀錄",
                    },
                    name: "associattion_coop_member_loginlog",
                    icon: "fa-history",
                    editshow: true,
                },
                ],
            },
            {
                title: {
                    CH: "裝置管理",
                },
                name: "associattion_coop_device",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回裝置管理",
                    },
                    name: "associattion_coop_device",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "associattion_coop_edit",
                },
                {
                    title: {
                        CH: "營業時間",
                    },
                    name: "associattion_coop_time",
                },
                {
                    title: {
                        CH: "人員管理",
                    },
                    name: "associattion_coop_member",
                },
                {
                    title: {
                        CH: "裝置管理",
                    },
                    name: "associattion_coop_device",
                },
                {
                    title: {
                        CH: "審查作業設定",
                    },
                    name: "associattion_coop_review",
                },
                {
                    title: {
                        CH: "放款開放設定",
                    },
                    name: "associattion_coop_lending",
                },
                ],
            },
            {
                title: {
                    CH: "審查作業設定",
                },
                name: "associattion_coop_review",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回審查作業設定",
                    },
                    name: "associattion_coop_review",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "associattion_coop_edit",
                },
                {
                    title: {
                        CH: "營業時間",
                    },
                    name: "associattion_coop_time",
                },
                {
                    title: {
                        CH: "人員管理",
                    },
                    name: "associattion_coop_member",
                },
                {
                    title: {
                        CH: "裝置管理",
                    },
                    name: "associattion_coop_device",
                },
                {
                    title: {
                        CH: "審查作業設定",
                    },
                    name: "associattion_coop_review",
                },
                {
                    title: {
                        CH: "放款開放設定",
                    },
                    name: "associattion_coop_lending",
                },
                ],
            },
            {
                title: {
                    CH: "放款開放設定",
                },
                name: "associattion_coop_lending",
                editshow: true,
            },
            ],
        },
        {
            title: {
                CH: "訊息管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "訊息設定",
                },
                name: "message",
            },
            {
                title: {
                    CH: "錯誤訊息管理",
                },
                name: "error_message",
            },
            ],
        },
        {
            title: {
                CH: "公告管理",
            },
            name: "announcement",
        },
        {
            title: {
                CH: "簡訊管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "使用記錄管理",
                },
                name: "association_sms_use",
            },
            {
                title: {
                    CH: "購買記錄管理",
                },
                name: "association_sms_buy",
            },
            {
                title: {
                    CH: "儲互社購買記錄管理",
                },
                name: "coop_sms_buy",
            },
            {
                title: {
                    CH: "儲互社使用記錄管理",
                },
                name: "coop_sms_use",
            },
            {
                title: {
                    CH: "簡訊相關設定",
                },
                name: "sms_setting",
            },
            ],
        },
        ],
    },
    {
        title: {
            CH: "安基業務管理",
        },
        name: "anji_business",
        icon: "fa-handshake-o",
        children: [{
            title: {
                CH: "收件作業",
            },
            name: "receiving_work",
        },
        {
            title: {
                CH: "儲互社安基資料管理",
            },
            name: "coop_anji",
            submenu: [{
                title: {
                    CH: "返回儲互社安基資料管理",
                },
                name: "coop_anji",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "開辦狀況",
                },
                name: "coop_anji_participation",
            },
            {
                title: {
                    CH: "社員參與狀況",
                },
                name: "coop_anji_memberparticipation",
            },
            {
                title: {
                    CH: "社員理賠管理",
                },
                name: "coop_anji_memberclaim",
            },
            ],
        },
        {
            title: {
                CH: "六年平儲",
            },
            name: "association_six_year",
            submenu: [{
                title: {
                    CH: "返回六年平儲",
                },
                name: "association_six_year",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "association_six_year_edit",
            },
            {
                title: {
                    CH: "開辦設定",
                },
                name: "association_six_year_start",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回開辦設定",
                    },
                    name: "association_six_year_start",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "association_six_year_edit",
                },
                {
                    title: {
                        CH: "開辦設定",
                    },
                    name: "association_six_year_start",
                },
                {
                    title: {
                        CH: "參數設定",
                    },
                    name: "association_six_year_parameter",
                },
                ],
            },
            {
                editshow: true,
                title: {
                    CH: "參數設定",
                },
                name: "association_six_year_parameter",
            },
            ],
        },
        {
            title: {
                CH: "LPLS",
            },
            name: "",
            children: [{
                title: {
                    CH: "參數設定",
                },
                name: "lpls_parameter",
            },
            {
                title: {
                    CH: "年度與保障期間設定",
                },
                name: "lpls_annual_guarantee",
            },
            {
                title: {
                    CH: "LP月費率及保額設定",
                },
                name: "lp_coop_rate",
            },
            {
                title: {
                    CH: "LS月費率及保額設定",
                },
                name: "ls_coop_rate",
            },
            {
                title: {
                    CH: "LPLS理賠申請",
                },
                name: "lpls_claim_application",
            },
            {
                title: {
                    CH: "LPLS 申報表公告設定",
                },
                name: "lpls_announcement",
            },
            ],
        },
        {
            title: {
                CH: "BOND",
            },
            name: "",
            children: [{
                title: {
                    CH: "參數設定",
                },
                name: "bond_parameter",
            },
            {
                title: {
                    CH: "年度與保障期間設定",
                },
                name: "bond_annual_guarantee",
            },
            {
                title: {
                    CH: "折扣率設定",
                },
                name: "bond_discount",
            },
            {
                title: {
                    CH: "年度續約申請管理",
                },
                name: "bond_annual_renewal",
            },
            {
                title: {
                    CH: "理賠申請管理",
                },
                name: "bond_bond_claim_application",
            },
            {
                title: {
                    CH: "相關報表",
                },
                name: "bond_report",
            },
            ],
        },
        //員工福利團體保險
        {
            title: {
                CH: "員工福利團體保險",
            },
            name: "employee",
            submenu: [{
                title: {
                    CH: "基本資料",
                },
                name: "employee",
            },
            {
                title: {
                    CH: "年度與保障期間設定",
                },
                name: "employee_annualguarantee",
                submenu: [{
                    title: {
                        CH: "返回年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "子方案設定",
                },
                name: "employee_subprogram",
                submenu: [{
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "會計科目設定",
                },
                name: "employee_accounting",
            },
            {
                title: {
                    CH: "相關文件設定",
                },
                name: "employee_doc",
            },
            {
                title: {
                    CH: "理賠項目與文件設定",
                },
                name: "employee_claimdoc",
            },
            {
                title: {
                    CH: "加退保名冊設定",
                },
                name: "employee_plussurrender",
            },
            {
                title: {
                    CH: "資料變更名冊設定",
                },
                name: "employee_changesurrender",
            },
            {
                title: {
                    CH: "參加名冊",
                },
                name: "employee_executiveroster",
                submenu: [{
                    title: {
                        CH: "返回參加名冊",
                    },
                    name: "employee_executiveroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            // {
            //     title: { CH: '退保申請名冊' },
            //     name: 'cadre_coopplusroster',
            //     submenu: [{
            //         title: { CH: '返回子方案設定' },
            //         name: 'cadre_subprogram',
            //         icon: 'fa-chevron-left'
            //     }, {
            //         title: { CH: '基本資料' },
            //         name: 'cadre',
            //     },
            //     {
            //         title: { CH: '年度與保障期間設定' },
            //         name: 'cadre_annualguarantee',
            //     },
            //     {
            //         title: { CH: '子方案設定' },
            //         name: 'cadre_subprogram',
            //     },
            //     {
            //         title: { CH: '會計科目設定' },
            //         name: 'cadre_accounting',
            //     },
            //     {
            //         title: { CH: '相關文件設定' },
            //         name: 'cadre_doc',
            //     },
            //     {
            //         title: { CH: '理賠項目與文件設定' },
            //         name: 'cadre_claimdoc',
            //     },
            //     {
            //         title: { CH: '加退保名冊設定' },
            //         name: 'cadre_plussurrender',
            //     },
            //     {
            //         title: { CH: '資料變更名冊設定' },
            //         name: 'cadre_changesurrender',
            //     },
            //     {
            //         title: { CH: '參加名冊' },
            //         name: 'cadre_executiveroster',
            //     },
            //     {
            //         title: { CH: '儲互社加退保申請送件' },
            //         name: 'cadre_coopplusdelivery',
            //     },
            //     {
            //         title: { CH: '加保申請名冊' },
            //         name: 'cadre_coopplusroster',
            //         query: 'plus',
            //     },
            //     {
            //         title: { CH: '加保申請通過名冊' },
            //         name: 'cadre_coopplusroster',
            //         query: 'pass'
            //     },
            //     {
            //         title: { CH: '加保申請不通過名冊' },
            //         name: 'cadre_coopplusroster',
            //         query: 'fail'
            //     },
            //     {
            //         title: { CH: '加保申請補件' },
            //         name: 'cadre_coopplusroster',
            //         query: 'add'
            //     },
            //     {
            //         title: { CH: '儲互社資料變更申請送件' },
            //         name: 'cadre_coopchangedelivery',
            //     },
            //     {
            //         title: { CH: '資料變更名冊' },
            //         name: 'cadre_changerostermanage',
            //     },
            //     {
            //         title: { CH: '理賠申請管理' },
            //         name: 'cadre_claimapplication',
            //     },
            //     ]
            // },
            {
                title: {
                    CH: "儲互社加退保申請送件",
                },
                name: "employee_coopplusdelivery",
                submenu: [{
                    title: {
                        CH: "返回儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請名冊",
                },
                name: "employee_coopplusroster",
                query: "plus",
                submenu: [{
                    title: {
                        CH: "返回加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請通過名冊",
                },
                name: "employee_coopplusroster",
                query: "pass",
            },
            {
                title: {
                    CH: "加保申請不通過名冊",
                },
                name: "employee_coopplusroster",
                query: "fail",
            },
            {
                title: {
                    CH: "加保申請補件",
                },
                name: "employee_coopplusroster",
                query: "add",
            },
            {
                title: {
                    CH: "退保申請名冊",
                },
                name: "employee_coopplusroster",
                query: "quit",
            },
            {
                title: {
                    CH: "資料變更名冊",
                },
                name: "employee_coopplusroster",
                query: "modify",
            },
            // {
            //     title: { CH: '儲互社資料變更申請送件' },
            //     name: 'cadre_coopchangedelivery',
            // },
            {
                title: {
                    CH: "儲互社資料變更申請送件",
                },
                name: "employee_coopchangedelivery",
                submenu: [{
                    title: {
                        CH: "返回儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "理賠申請管理",
                },
                name: "employee_claimapplication",
                submenu: [{
                    title: {
                        CH: "返回理賠申請管理",
                    },
                    name: "employee_claimapplication",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employee",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "employee_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "employee_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "employee_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "employee_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "employee_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "employee_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "employee_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "employee_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "employee_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "employee_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "employee_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "employee_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "employee_claimapplication",
                },
                ],
            },
            ],
        },

        {
            title: {
                CH: "幹部保險方案設定",
            },
            name: "cadre",
            submenu: [{
                title: {
                    CH: "基本資料",
                },
                name: "cadre",
            },
            {
                title: {
                    CH: "年度與保障期間設定",
                },
                name: "cadre_annualguarantee",
                submenu: [{
                    title: {
                        CH: "返回年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_handlingFee",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "子方案設定",
                },
                name: "cadre_subprogram",
                submenu: [{
                    title: {
                        CH: "返回子方案設定",
                    },
                    name: "cadre_subprogram",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_handlingFee",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },
                // {
                //     title: { CH: '儲互社資料變更名冊' },
                //     name: 'cadre_coopchangedelivery',
                // },

                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "經辦費設定",
                },
                name: "cadre_handlingFee",
            },
            {
                title: {
                    CH: "會計科目設定",
                },
                name: "cadre_accounting",
            },
            {
                title: {
                    CH: "相關文件設定",
                },
                name: "cadre_doc",
            },
            {
                title: {
                    CH: "理賠項目與文件設定",
                },
                name: "cadre_claimdoc",
            },
            {
                title: {
                    CH: "加退保名冊設定",
                },
                name: "cadre_plussurrender",
            },
            {
                title: {
                    CH: "資料變更名冊設定",
                },
                name: "cadre_changesurrender",
            },
            {
                title: {
                    CH: "參加名冊",
                },
                name: "cadre_executiveroster",
                submenu: [{
                    title: {
                        CH: "返回參加名冊",
                    },
                    name: "cadre_executiveroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            // {
            //     title: { CH: '退保申請名冊' },
            //     name: 'cadre_coopplusroster',
            //     submenu: [{
            //         title: { CH: '返回子方案設定' },
            //         name: 'cadre_subprogram',
            //         icon: 'fa-chevron-left'
            //     }, {
            //         title: { CH: '基本資料' },
            //         name: 'cadre',
            //     },
            //     {
            //         title: { CH: '年度與保障期間設定' },
            //         name: 'cadre_annualguarantee',
            //     },
            //     {
            //         title: { CH: '子方案設定' },
            //         name: 'cadre_subprogram',
            //     },
            //     {
            //         title: { CH: '會計科目設定' },
            //         name: 'cadre_accounting',
            //     },
            //     {
            //         title: { CH: '相關文件設定' },
            //         name: 'cadre_doc',
            //     },
            //     {
            //         title: { CH: '理賠項目與文件設定' },
            //         name: 'cadre_claimdoc',
            //     },
            //     {
            //         title: { CH: '加退保名冊設定' },
            //         name: 'cadre_plussurrender',
            //     },
            //     {
            //         title: { CH: '資料變更名冊設定' },
            //         name: 'cadre_changesurrender',
            //     },
            //     {
            //         title: { CH: '參加名冊' },
            //         name: 'cadre_executiveroster',
            //     },
            //     {
            //         title: { CH: '儲互社加退保申請送件' },
            //         name: 'cadre_coopplusdelivery',
            //     },
            //     {
            //         title: { CH: '加保申請名冊' },
            //         name: 'cadre_coopplusroster',
            //         query: 'plus',
            //     },
            //     {
            //         title: { CH: '加保申請通過名冊' },
            //         name: 'cadre_coopplusroster',
            //         query: 'pass'
            //     },
            //     {
            //         title: { CH: '加保申請不通過名冊' },
            //         name: 'cadre_coopplusroster',
            //         query: 'fail'
            //     },
            //     {
            //         title: { CH: '加保申請補件' },
            //         name: 'cadre_coopplusroster',
            //         query: 'add'
            //     },
            //     {
            //         title: { CH: '儲互社資料變更申請送件' },
            //         name: 'cadre_coopchangedelivery',
            //     },
            //     {
            //         title: { CH: '資料變更名冊' },
            //         name: 'cadre_changerostermanage',
            //     },
            //     {
            //         title: { CH: '理賠申請管理' },
            //         name: 'cadre_claimapplication',
            //     },
            //     ]
            // },
            {
                title: {
                    CH: "儲互社加退保申請送件",
                },
                name: "cadre_coopplusdelivery",
                submenu: [{
                    title: {
                        CH: "返回儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_handlingFee",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },

                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請名冊",
                },
                name: "cadre_coopplusroster",
                query: "plus",
                submenu: [{
                    title: {
                        CH: "返回加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_handlingFee",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請通過名冊",
                },
                name: "cadre_coopplusroster",
                query: "pass",
            },
            {
                title: {
                    CH: "加保申請不通過名冊",
                },
                name: "cadre_coopplusroster",
                query: "fail",
            },
            {
                title: {
                    CH: "加保申請補件",
                },
                name: "cadre_coopplusroster",
                query: "add",
            },
            {
                title: {
                    CH: "退保申請名冊",
                },
                name: "cadre_coopplusroster",
                query: "quit",
            },
            {
                title: {
                    CH: "資料變更名冊",
                },
                name: "cadre_coopplusroster",
                query: "modify",
            },
            // {
            //     title: { CH: '儲互社資料變更申請送件' },
            //     name: 'cadre_coopchangedelivery',
            // },
            {
                title: {
                    CH: "儲互社資料變更申請送件",
                },
                name: "cadre_coopchangedelivery",
                submenu: [{
                    title: {
                        CH: "返回儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_handlingFee",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_changerostermanage",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "理賠申請管理",
                },
                name: "cadre_claimapplication",
                submenu: [{
                    title: {
                        CH: "返回理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadre",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "cadre_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "cadre_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "cadre_handlingFee",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "cadre_accounting",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "cadre_doc",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "cadre_claimdoc",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "cadre_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "cadre_changesurrender",
                },
                {
                    title: {
                        CH: "參加名冊",
                    },
                    name: "cadre_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "cadre_coopplusdelivery",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "加保申請通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "加保申請不通過名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "加保申請補件",
                    },
                    name: "cadre_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadre_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "資料變更名冊",
                    },
                    name: "cadre_changerostermanage",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "cadre_coopchangedelivery",
                },
                {
                    title: {
                        CH: "理賠申請管理",
                    },
                    name: "cadre_claimapplication",
                },
                ],
            },
            ],
        },
        {
            title: {
                CH: "代辦互助基金",
            },
            name: "agency",
            submenu: [{
                title: {
                    CH: "返回代辦互助基金",
                },
                name: "agency",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "agency_edit",
                editshow: true,
            },
            {
                title: {
                    CH: "年度與保障期間設定",
                },
                editshow: true,
                name: "agency_annualguarantee",
                submenu: [{
                    title: {
                        CH: "返回年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "子方案設定",
                },
                editshow: true,
                name: "agency_subprogram",
                submenu: [{
                    title: {
                        CH: "返回子方案設定",
                    },
                    name: "agency_subprogram",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "經辦費設定",
                },
                editshow: true,
                name: "agency_handlingFee",
                submenu: [{
                    title: {
                        CH: "返回經辦費設定",
                    },
                    name: "agency_handlingFee",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "加退保名冊設定",
                },
                editshow: true,
                name: "agency_plussurrender",
            },
            {
                title: {
                    CH: "資料變更名冊設定",
                },
                editshow: true,
                name: "agency_changesurrender",
            },
            {
                title: {
                    CH: "相關文件設定",
                },
                editshow: true,
                name: "agency_doc",
            },
            {
                title: {
                    CH: "會計科目設定",
                },
                editshow: true,
                name: "agency_accounting",
            },
            {
                title: {
                    CH: "理賠項目與文件設定",
                },
                editshow: true,
                name: "agency_claimsdoc",
            },
            {
                title: {
                    CH: "儲互社開辦管理",
                },
                editshow: true,
                name: "agency_coopstart",
                submenu: [{
                    title: {
                        CH: "返回儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "相關報表",
                },
                name: "agency_report",
                editshow: true,
            },
            {
                title: {
                    CH: "儲互社參加名冊",
                },
                editshow: true,
                name: "agency_executiveroster",
                submenu: [{
                    title: {
                        CH: "返回儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "儲互社加退保申請送件",
                },
                editshow: true,
                name: "agency_coopplusdelivery",
                submenu: [{
                    title: {
                        CH: "返回儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "儲互社加保申請名冊",
                },
                editshow: true,
                name: "agency_coopplusroster",
                query: "plus",
                submenu: [{
                    title: {
                        CH: "返回儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },

                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "儲互社加保申請通過名單",
                },
                editshow: true,
                name: "agency_coopplusroster",
                query: "pass",
            },
            {
                title: {
                    CH: "儲互社加保申請不通過名單",
                },
                editshow: true,
                name: "agency_coopplusroster",
                query: "fail",
            },
            {
                title: {
                    CH: "儲互社加保申請補件名單",
                },
                editshow: true,
                name: "agency_coopplusroster",
                query: "add",
            },
            {
                title: {
                    CH: "儲互社退保申請名冊",
                },
                editshow: true,
                name: "agency_coopplusroster",
                query: "quit",
            },
            {
                title: {
                    CH: "儲互社資料變更申請名冊",
                },
                editshow: true,
                name: "agency_coopplusroster",
                query: "modify",
            },
            {
                title: {
                    CH: "儲互社資料變更申請送件",
                },
                editshow: true,
                name: "agency_coopchangedelivery",
                submenu: [{
                    title: {
                        CH: "返回儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            {
                title: {
                    CH: "儲互社理賠申請",
                },
                editshow: true,
                name: "agency_coopclaimapplication",
                submenu: [{
                    title: {
                        CH: "返回儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agency_edit",
                },
                {
                    title: {
                        CH: "年度與保障期間設定",
                    },
                    name: "agency_annualguarantee",
                },
                {
                    title: {
                        CH: "子方案設定",
                    },
                    name: "agency_subprogram",
                },
                {
                    title: {
                        CH: "經辦費設定",
                    },
                    name: "agency_handlingFee",
                },
                {
                    title: {
                        CH: "加退保名冊設定",
                    },
                    name: "agency_plussurrender",
                },
                {
                    title: {
                        CH: "資料變更名冊設定",
                    },
                    name: "agency_changesurrender",
                },
                {
                    title: {
                        CH: "相關文件設定",
                    },
                    name: "agency_doc",
                },
                {
                    title: {
                        CH: "會計科目設定",
                    },
                    name: "agency_accounting",
                },
                {
                    title: {
                        CH: "理賠項目與文件設定",
                    },
                    name: "agency_claimsdoc",
                },
                {
                    title: {
                        CH: "儲互社開辦管理",
                    },
                    name: "agency_coopstart",
                },
                {
                    title: {
                        CH: "相關報表",
                    },
                    name: "agency_report",
                },
                {
                    title: {
                        CH: "儲互社參加名冊",
                    },
                    name: "agency_executiveroster",
                },
                {
                    title: {
                        CH: "儲互社加退保申請送件",
                    },
                    name: "agency_coopplusdelivery",
                },
                {
                    title: {
                        CH: "儲互社加保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "plus",
                },
                {
                    title: {
                        CH: "儲互社加保申請通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "pass",
                },
                {
                    title: {
                        CH: "儲互社加保申請不通過名單",
                    },
                    name: "agency_coopplusroster",
                    query: "fail",
                },
                {
                    title: {
                        CH: "儲互社加保申請補件名單",
                    },
                    name: "agency_coopplusroster",
                    query: "add",
                },
                {
                    title: {
                        CH: "儲互社退保申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "quit",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請名冊",
                    },
                    name: "agency_coopplusroster",
                    query: "modify",
                },
                {
                    title: {
                        CH: "儲互社資料變更申請送件",
                    },
                    name: "agency_coopchangedelivery",
                },
                {
                    title: {
                        CH: "儲互社理賠申請",
                    },
                    name: "agency_coopclaimapplication",
                },
                ],
            },
            ],
        },
        ],
    },
    {
        title: {
            CH: "督導資料查詢",
        },
        name: "supervision",
        icon: "fa-tasks",
        children: [{
            title: {
                CH: "督導業務查詢",
            },
            name: "supervision",
        },
        {
            title: {
                CH: "儲互社管理",
            },
            name: "super_coop",
            submenu: [{
                title: {
                    CH: "返回業務督導查詢",
                },
                name: "supervision",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "返回儲互社管理",
                },
                name: "super_coop",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "super_coop_edit",
            },
            {
                title: {
                    CH: "營業時間",
                },
                name: "super_coop_time",
                editshow: true,
            },
            {
                title: {
                    CH: "人員管理",
                },
                name: "super_coop_member",
                submenu: [{
                    title: {
                        CH: "返回人員管理",
                    },
                    name: "super_coop_member",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "super_coop_member_edit",
                },
                {
                    title: {
                        CH: "角色設定",
                    },
                    name: "super_coop_member_role",
                },
                // {
                //     title: { CH: '權限設定' },
                //     name: 'super_coop_member_permission',
                // },
                {
                    title: {
                        CH: "登入紀錄",
                    },
                    name: "super_coop_member_loginlog",
                    icon: "fa-history",
                },
                ],
            },
            {
                title: {
                    CH: "裝置管理",
                },
                name: "super_coop_device",
                submenu: [{
                    title: {
                        CH: "返回裝置管理",
                    },
                    name: "super_coop_device",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "super_coop_edit",
                },
                {
                    title: {
                        CH: "營業時間",
                    },
                    name: "super_coop_time",
                },
                {
                    title: {
                        CH: "人員管理",
                    },
                    name: "super_coop_member",
                },
                {
                    title: {
                        CH: "裝置管理",
                    },
                    name: "super_coop_device",
                },
                {
                    title: {
                        CH: "資料查詢",
                    },
                    name: "super_coop_search",
                },
                {
                    title: {
                        CH: "出勤狀態查詢",
                    },
                    name: "super_coop_attendance",
                },
                {
                    title: {
                        CH: "查核工作底稿",
                    },
                    name: "super_coop_checkwork",
                },
                ],
            },
            {
                title: {
                    CH: "資料查詢",
                },
                name: "super_coop_search",
            },
            {
                title: {
                    CH: "出勤狀態查詢",
                },
                name: "super_coop_attendance",
            },
            {
                title: {
                    CH: "查核工作底稿",
                },
                name: "super_coop_checkwork",
                submenu: [{
                    title: {
                        CH: "返回查核工作底稿",
                    },
                    name: "super_coop_checkwork",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "super_coop_edit",
                },
                {
                    title: {
                        CH: "營業時間",
                    },
                    name: "super_coop_time",
                },
                {
                    title: {
                        CH: "人員管理",
                    },
                    name: "super_coop_member",
                },
                {
                    title: {
                        CH: "裝置管理",
                    },
                    name: "super_coop_device",
                },
                {
                    title: {
                        CH: "資料查詢",
                    },
                    name: "super_coop_search",
                },
                {
                    title: {
                        CH: "出勤狀態查詢",
                    },
                    name: "super_coop_attendance",
                },
                {
                    title: {
                        CH: "查核工作底稿",
                    },
                    name: "super_coop_checkwork",
                },
                ],
            },
            ],
        },
        {
            title: {
                CH: "借款條件異動處理審核",
            },
            name: "supervision_business_iou_modify_review",
        },

        {
            title: {
                CH: "業務審核",
            },
            name: "supervision_business_review",
        },
        ],
    },
    {
        title: {
            CH: "督導組組長",
        },
        name: "supervision_leader",
        icon: "fa-tasks",
        children: [{
            title: {
                CH: "業務審核",
            },
            name: "supervision_leader",
        },],
    },
    ],
    coop: [{
        title: {
            CH: "人事差勤系統",
        },
        name: "attendance",
        children: [{
            title: {
                CH: "個人請假管理",
            },
            name: "leave",
        },
        {
            title: {
                CH: "登入紀錄查詢",
            },
            name: "attendance_login_log",
        },
        {
            title: {
                CH: "代理人歷史紀錄查詢",
            },
            name: "agent_attendance_login_log",
        },
        {
            title: {
                CH: "使用者帳號管理",
            },
            name: "attendance_admin",
            submenu: [{
                title: {
                    CH: "返回使用者帳號管理",
                },
                name: "attendance_admin",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "attendance_admin_edit",
            },
            {
                title: {
                    CH: "角色設定",
                },
                name: "attendance_admin_role",
            },
            // {
            //     title: { CH: '權限設定' },
            //     name: 'attendance_admin_permission',
            // },
            {
                title: {
                    CH: "登入紀錄",
                },
                name: "attendance_admin_loginlog",
                icon: "fa-history",
            },
            ],
        },
        ],
    },
    {
        title: {
            CH: "系統管理",
        },
        name: "coop_system",
        children: [{
            title: {
                CH: "作業參數設定",
            },
            name: "coop_parameter",
        },
        {
            title: {
                CH: "審查作業設定",
            },
            name: "coop_system_review",
        },
        {
            title: {
                CH: "儲互社基本資料管理",
            },
            name: "coop_information",
            submenu: [{
                title: {
                    CH: "基本資料",
                },
                name: "coop_information_edit",
            },
            {
                title: {
                    CH: "營業時間",
                },
                name: "coop_information_time",
            },
            ],
        },
        {
            title: {
                CH: "會計科目查詢",
            },
            name: "coop_accounting",
        },
        {
            title: {
                CH: "歷屆選任理監事名單",
            },
            name: "list_supervisors",
        },
        {
            title: {
                CH: "歷屆聘任幹部名單",
            },
            name: "list_cadre",
        },
        {
            title: {
                CH: "會議記錄管理",
            },
            name: "meeting_record",
        },
        {
            title: {
                CH: "聘僱人員名單",
            },
            name: "hire_employee",
        },
        {
            title: {
                CH: "中文詞彙資料管理",
            },
            name: "chinese_vocabulary",
        },
        {
            title: {
                CH: "簡訊使用管理",
            },
            name: "sms_use",
        },
        {
            title: {
                CH: "簡訊購買記錄管理",
            },
            name: "sms_buy",
            submenu: [{
                title: {
                    CH: "返回簡訊購買記錄管理",
                },
                name: "sms_buy",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "建立申請",
                },
                name: "sms_buy_edit",
            },
            {
                title: {
                    CH: "主任審查",
                },
                name: "sms_buy_review",
                queery: "director",
            },
            {
                title: {
                    CH: "經理審查",
                },
                name: "sms_buy_review",
                queery: "manager",
            },
            {
                title: {
                    CH: "數量轉移",
                },
                name: "sms_buy_review",
                queery: "transfer",
            },
            ],
        },
        {
            title: {
                CH: "銀行帳戶管理",
            },
            name: "bank_account",
        },
        ],
    },
    {
        title: {
            CH: "臨櫃作業",
        },
        name: "cabinet",
        children: [{
            title: {
                CH: "社員搜尋",
            },
            name: "cabinet_search",
        },
        {
            title: {
                CH: "準社員管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "準社員入社申請資料管理",
                },
                name: "quasi_member_join",
                submenu: [{
                    title: {
                        CH: "返回準社員入社申請資料管理",
                    },
                    name: "quasi_member_join",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "上傳入社申請書",
                    },
                    name: "quasi_member_join_edit",
                },
                {
                    title: {
                        CH: "主任審查紀錄",
                    },
                    name: "quasi_member_join_review",
                    query: "director",
                },
                {
                    title: {
                        CH: "經理審查紀錄",
                    },
                    name: "quasi_member_join_review",
                    query: "manager",
                },
                {
                    title: {
                        CH: "理事會審查紀錄",
                    },
                    name: "quasi_member_join_review",
                    query: "council",
                },
                {
                    title: {
                        CH: "輸入準社員資料",
                    },
                    name: "quasi_member_join_info",
                },
                ],
            },
            {
                title: {
                    CH: "準社員資料管理列表",
                },
                name: "quasi_member",
                submenu: [{
                    title: {
                        CH: "返回準社員資料管理列表",
                    },
                    name: "quasi_member",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "準社員資料管理",
                    },
                    name: "quasi_member_info",
                },
                {
                    title: {
                        CH: "傳票管理",
                    },
                    name: "quasi_member_deposit",
                },
                    /*         {
                                    title: { CH: '傳票管理' },
                                    name: 'quasi_member_deposit',
                                },
                                {
                                    title: { CH: '取消申請' },
                                    name: 'quasi_member_review',
                                    query: 'cancelApplication'
                                }, */
                    /*       {
                                  title: { CH: '取消申請主任審查' },
                                  name: 'quasi_member_review',
                                  query: 'director'
                              },
                              {
                                  title: { CH: '取消申請經理審查' },
                                  name: 'quasi_member_review',
                                  query: 'manager'
                              },
                              {
                                  title: { CH: '取消申請理事會審查' },
                                  name: 'quasi_member_review',
                                  query: 'council'
                              }, */
                ],
            },
            {
                title: {
                    CH: "準社員升社員作業",
                },
                name: "associate_member",
                submenu: [{
                    title: {
                        CH: "返回準社員升社員作業",
                    },
                    name: "associate_member",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "總覽",
                    },
                    name: "associate_member_edit",
                },
                {
                    title: {
                        CH: "主任審查",
                    },
                    name: "associate_member_review",
                    query: "director",
                },
                {
                    title: {
                        CH: "經理審查",
                    },
                    name: "associate_member_review",
                    query: "manager",
                },
                {
                    title: {
                        CH: "理事會審查",
                    },
                    name: "associate_member_review",
                    query: "council",
                },
                {
                    title: {
                        CH: "準社員資料轉換",
                    },
                    name: "associate_member_conversion",
                },
                ],
            },
            {
                title: {
                    CH: "準社員個人帳",
                },
                name: "quasi_member_personal_report",
            },
            {
                title: {
                    CH: "準社員升社員明細表",
                },
                name: "quasi_member_to_member_list",
            },
            ],
        },
        {
            title: {
                CH: "社員管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "社員資料管理",
                },
                name: "member",
                submenu: [{
                    title: {
                        CH: "返回社員資料管理",
                    },
                    name: "member",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "member_edit",
                },
                {
                    title: {
                        CH: "利害關係人",
                    },
                    name: "member_stakes",
                    submenu: [{
                        title: {
                            CH: "返回利害關係人",
                        },
                        name: "member_stakes",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "基本資料",
                        },
                        name: "member_edit",
                    },
                    {
                        title: {
                            CH: "利害關係人",
                        },
                        name: "member_stakes",
                    },
                    {
                        title: {
                            CH: "股金管理",
                        },
                        name: "member_stock",
                        editshow: true,
                    },
                    {
                        title: {
                            CH: "備轉金管理",
                        },
                        name: "member_transfer",
                        editshow: true,
                    },
                    {
                        title: {
                            CH: "安基管理",
                        },
                        name: "member_anji",
                        editshow: true,
                    },
                    {
                        title: {
                            CH: "放款管理",
                        },
                        name: "member_loan",
                        editshow: true,
                    },
                    {
                        title: {
                            CH: "放款個人帳",
                        },
                        name: "member_record",
                    },
                    {
                        title: {
                            CH: "薪資轉帳",
                        },
                        name: "member_payroll",
                    },
                    {
                        title: {
                            CH: "委託轉帳",
                        },
                        name: "member_commission",
                    },
                    {
                        title: {
                            CH: "記事",
                        },
                        name: "member_note",
                    },
                    {
                        title: {
                            CH: "相關傳票",
                        },
                        name: "member_summons",
                    },
                    {
                        title: {
                            CH: "六年平儲",
                        },
                        name: "member_sixyear",
                    },
                    {
                        title: {
                            CH: "超額/逾齡股金管理",
                        },
                        name: "member_overstock",
                        editshow: true,
                        isSubMenu: true,
                        submenu: [{
                            title: {
                                CH: "返回超額/逾齡股金管理"
                            },
                            name: "member_overstock",
                            icon: "fa-chevron-left",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "基本資料"
                            },
                            name: "member_edit",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "利害關係人"
                            },
                            name: "member_stakes",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "股金管理"
                            },
                            name: "member_stock",
                            editshow: true,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "備轉金管理"
                            },
                            name: "member_transfer",
                            editshow: true,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "安基管理"
                            },
                            name: "member_anji",
                            editshow: true,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "放款管理"
                            },
                            name: "member_loan",
                            editshow: true,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "放款個人帳"
                            },
                            name: "member_record",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "薪資轉帳"
                            },
                            name: "member_payroll",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "委託轉帳"
                            },
                            name: "member_commission",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "記事"
                            },
                            name: "member_note",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "相關傳票"
                            },
                            name: "member_summons",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "六年平儲"
                            },
                            name: "member_sixyear",
                            editshow: false,
                            isSubMenu: true
                        },
                        {
                            title: {
                                CH: "超額/逾齡股金管理"
                            },
                            name: "member_overstock",
                            editshow: true,
                            isSubMenu: true
                        }]
                    },
                    ],
                },
                {
                    title: {
                        CH: "股金管理",
                    },
                    name: "member_stock",
                    editshow: true,
                },
                {
                    title: {
                        CH: "備轉金管理",
                    },
                    name: "member_transfer",
                    editshow: true,
                },
                {
                    title: {
                        CH: "安基管理",
                    },
                    name: "member_anji",
                    editshow: true,
                },
                {
                    title: {
                        CH: "放款管理",
                    },
                    name: "member_loan",
                    editshow: true,
                },
                {
                    title: {
                        CH: "放款個人帳",
                    },
                    name: "member_record",
                },
                {
                    title: {
                        CH: "薪資轉帳",
                    },
                    name: "member_payroll",
                },
                {
                    title: {
                        CH: "委託轉帳",
                    },
                    name: "member_commission",
                },
                {
                    title: {
                        CH: "記事",
                    },
                    name: "member_note",
                },
                {
                    title: {
                        CH: "相關傳票",
                    },
                    name: "member_summons",
                },
                {
                    title: {
                        CH: "六年平儲",
                    },
                    name: "member_sixyear",
                },
                {
                    title: {
                        CH: "超額/逾齡股金管理",
                    },
                    name: "member_overstock",
                    editshow: true,
                },
                ],
            },
            {
                title: {
                    CH: "社員群組管理",
                },
                name: "member_group",
                submenu: [{
                    title: {
                        CH: "返回社員群組管理",
                    },
                    name: "member_group",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "member_group_edit",
                },
                {
                    title: {
                        CH: "群組人員",
                    },
                    name: "member_group_staff",
                    editshow: true,
                },
                ],
            },
            {
                title: {
                    CH: "股金及放款個人帳",
                },
                name: "member_personal_account",
            },
            {
                title: {
                    CH: "社員總帳",
                },
                name: "member_general_ledger",
            },
            {
                title: {
                    CH: "退社管理",
                },
                name: "member_drop_out",
            },
            {
                title: {
                    CH: "社員轉出管理",
                },
                name: "transfer_out",
            },
            {
                title: {
                    CH: "社員轉入管理",
                },
                name: "transfer_in",
            },
            {
                title: {
                    CH: "退股金管理",
                },
                name: "withdrawal",
            },
            {
                title: {
                    CH: "備轉金個人帳",
                },
                name: "member_shares_report",
            },
            ],
        },
        // {
        //     title: { CH: '備查簿' },
        //     name: '',
        //     children: [{
        //         title: { CH: '台幣定存單管理' },
        //         name: 'deposit_order',
        //         submenu: [{
        //             title: { CH: '返回台幣定存單管理' },
        //             name: 'deposit_order',
        //             icon: 'fa-chevron-left'
        //         }, {
        //             title: { CH: '基本資料' },
        //             name: 'deposit_order_edit',
        //         }, {
        //             title: { CH: '相關傳票' },
        //             name: 'deposit_order_summons',
        //             editshow: true,
        //             submenu: [{
        //                 title: { CH: '返回台幣定存單管理' },
        //                 name: 'deposit_order',
        //                 icon: 'fa-chevron-left'
        //             }, {
        //                 title: { CH: '基本資料' },
        //                 name: 'deposit_order_edit',
        //             }, {
        //                 title: { CH: '相關傳票' },
        //                 name: 'deposit_order_summons',
        //             }]
        //         }]
        //     },
        //         // 先隱藏
        //         // {
        //         //     title: { CH: '零用金備查簿' },
        //         //     name: 'cash_reference',
        //         // },
        //     ]
        // },
        {
            title: {
                CH: "台幣定存單管理",
            },
            name: "deposit_order",
            submenu: [{
                title: {
                    CH: "返回台幣定存單管理",
                },
                name: "deposit_order",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "deposit_order_edit",
            },
            {
                title: {
                    CH: "相關傳票",
                },
                name: "deposit_order_summons",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回台幣定存單管理",
                    },
                    name: "deposit_order",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "deposit_order_edit",
                },
                {
                    title: {
                        CH: "相關傳票",
                    },
                    name: "deposit_order_summons",
                },
                ],
            },
            ],
        },

        {
            title: {
                CH: "資料查印",
            },
            name: "",
            children: [{
                title: {
                    CH: "放款本息",
                },
                name: "loan_interest",
            },
            {
                title: {
                    CH: "到期應還本息",
                },
                name: "due_interest",
            },
            {
                title: {
                    CH: "放款逾期一覽表",
                },
                name: "loan_overdue",
            },
            {
                title: {
                    CH: "放款催收明細表",
                },
                name: "loan_overdue_colt_list",
            },
            {
                title: {
                    CH: "放款一覽表",
                },
                name: "loan_list",
            },
            {
                title: {
                    CH: "放款協議清單",
                },
                name: "loan_agreement",
            },
            {
                title: {
                    CH: "逾期約定償還協議清單",
                },
                name: "agreement_repayment",
            },
            {
                title: {
                    CH: "個人貸款資料",
                },
                name: "personal_loan",
            },
            {
                title: {
                    CH: "借據還款記錄表",
                },
                name: "repayment_record",
            },
            {
                title: {
                    CH: "預定還款表",
                },
                name: "schedule_repayment",
            },
            {
                title: {
                    CH: "放款逾期１至３個月明細表",
                },
                name: "onethree_schedule",
            },
            {
                title: {
                    CH: "保証人查詢",
                },
                name: "guarantor_search",
            },
            {
                title: {
                    CH: "社員名冊",
                },
                name: "member_roster",
            },
            {
                title: {
                    CH: "幹部名冊",
                },
                name: "cadre_roster",
            },
            {
                title: {
                    CH: "郵遞標籤",
                },
                name: "zipcode_label",
            },
            {
                title: {
                    CH: "月份壽星",
                },
                name: "month_birthday",
            },
            // {
            //     title: { CH: '定額/還款試算' },
            //     name: 'repayment_calc'
            // },
            {
                title: {
                    CH: "貸款利息應收實收比較表",
                },
                name: "interest_comparison",
            },
            {
                title: {
                    CH: "當月未存款名單",
                },
                name: "no_deposit",
            },
            {
                title: {
                    CH: "應還未還款名單",
                },
                name: "no_paid",
            },
            {
                title: {
                    CH: "入社退社名單",
                },
                name: "inout_list",
            },
            {
                title: {
                    CH: "社員簽到簿",
                },
                name: "member_checklist",
            },
            {
                title: {
                    CH: "股金全勤表",
                },
                name: "stocks_attendance",
            },
            {
                title: {
                    CH: "還款表",
                },
                name: "repayment_form",
            },
            {
                title: {
                    CH: "各項結餘排行",
                },
                name: "balance_ranking",
            },
            {
                title: {
                    CH: "年齡分析表",
                },
                name: "age_analysis",
            },
            ],
        },
        ],
    },
    {
        title: {
            CH: "安基作業",
        },
        name: "anji",
        children: [{
            title: {
                CH: "LPLS",
            },
            name: "",
            children: [{
                title: {
                    CH: "開辦查詢",
                },
                name: "start",
            },
            {
                title: {
                    CH: "理賠申請管理",
                },
                name: "claim_application",
            },
            {
                title: {
                    CH: "逾齡股金及放款",
                },
                name: "lpls_report",
                query: "逾齡股金及放款",
            },
            {
                title: {
                    CH: "逾齡備轉金",
                },
                name: "lpls_report",
                query: "逾齡備轉金",
            },
            {
                title: {
                    CH: "超額股金及放款",
                },
                name: "lpls_report",
                query: "超額股金及放款",
            },
            {
                title: {
                    CH: "超額備轉金",
                },
                name: "lpls_report",
                query: "超額備轉金",
            },
            {
                title: {
                    CH: "法人股金及放款",
                },
                name: "lpls_report",
                query: "法人股金及放款",
            },
            {
                title: {
                    CH: "法人備轉金",
                },
                name: "lpls_report",
                query: "法人備轉金",
            },
            {
                title: {
                    CH: "不合格放款",
                },
                name: "lpls_report",
                query: "不合格放款",
            },
            {
                title: {
                    CH: "股金超過3000元",
                },
                name: "lpls_report",
                query: "股金超過3000元",
            },
            {
                title: {
                    CH: "逾期18個月放款",
                },
                name: "lpls_report",
                query: "逾期18個月放款",
            },
            {
                title: {
                    CH: "青年附加契約明細表",
                },
                name: "lpls_report",
                query: "青年附加契約明細表",
            },
            {
                title: {
                    CH: "LS個人最高給付額表",
                },
                name: "lpls_report",
                query: "LS個人最高給付額表",
            },
            {
                title: {
                    CH: "互助費LPLS申報表",
                },
                name: "lpls_report",
                query: "互助費LPLS申報表",
            },
            {
                title: {
                    CH: "LPLS理賠個人帳資料匯出(平民銀行專案用)",
                },
                name: "lpls_claim_personal",
            },
            {
                title: {
                    CH: "LPLS明細對帳單",
                },
                name: "lpls_detail_statement",
            },

            ],
        },
        {
            title: {
                CH: "BOND",
            },
            name: "",
            children: [{
                title: {
                    CH: "年度續約申請",
                },
                name: "renew_bond",
            },
            {
                title: {
                    CH: "歷史紀錄查詢",
                },
                name: "bond_history",
            },
            {
                title: {
                    CH: "理賠申請",
                },
                name: "bond_claim",
            },
            ],
        },
        {
            title: {
                CH: "協會代辦互助基金",
            },
            name: "agent",
            submenu: [{
                title: {
                    CH: "返回協會代辦互助基金",
                },
                name: "agent",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "agent_edit",
            },
            {
                title: {
                    CH: "互助費與經辦費明細",
                },
                name: "agent_mutual",
            },
            {
                title: {
                    CH: "相關文件",
                },
                name: "agent_paper",
            },
            {
                title: {
                    CH: "執行中名冊",
                },
                name: "agent_executiveroster",
                submenu: [{
                    title: {
                        CH: "返回執行中名冊",
                    },
                    name: "agent_executiveroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請名冊",
                },
                name: "agent_plusroster",
                submenu: [{
                    title: {
                        CH: "返回加保申請名冊",
                    },
                    name: "agent_plusroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "退保申請名冊",
                },
                name: "agent_surrenderroster",
                submenu: [{
                    title: {
                        CH: "返回退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "加退保合併送件",
                },
                name: "agent_merge",
                submenu: [{
                    title: {
                        CH: "返回加退保合併送件",
                    },
                    name: "agent_merge",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "資料變更申請名冊",
                },
                name: "agent_changeroster",
                submenu: [{
                    title: {
                        CH: "返回資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "資料變更合併送件",
                },
                name: "agent_changemerge",
                submenu: [{
                    title: {
                        CH: "返回資料變更合併送件",
                    },
                    name: "agent_changemerge",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "理賠申請",
                },
                name: "agent_claim",
                submenu: [{
                    title: {
                        CH: "返回理賠申請",
                    },
                    name: "agent_claim",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "帳務處理",
                },
                name: "agent_accounting",
                submenu: [{
                    title: {
                        CH: "返回理賠申請",
                    },
                    name: "agent_claim",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "agent_edit",
                },
                {
                    title: {
                        CH: "互助費與經辦費明細",
                    },
                    name: "agent_mutual",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "agent_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "agent_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "agent_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "agent_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "agent_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "agent_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "agent_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "agent_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "agent_accounting",
                },
                ],
            },
            ],
        },
        {
            title: {
                CH: "幹部互助基金",
            },
            name: "cadrecoop",
            submenu: [{
                title: {
                    CH: "基本資料",
                },
                name: "cadrecoop",
            },
            {
                title: {
                    CH: "相關文件",
                },
                name: "cadrecoop_paper",
            },
            {
                title: {
                    CH: "執行中名冊",
                },
                name: "cadrecoop_executiveroster",
                submenu: [{
                    title: {
                        CH: "返回執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請名冊",
                },
                name: "cadrecoop_plusroster",
                submenu: [{
                    title: {
                        CH: "返回加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            {
                title: {
                    CH: "退保申請名冊",
                },
                name: "cadrecoop_surrenderroster",
                submenu: [{
                    title: {
                        CH: "返回退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            {
                title: {
                    CH: "加退保合併送件",
                },
                name: "cadrecoop_merge",
                submenu: [{
                    title: {
                        CH: "返回加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            {
                title: {
                    CH: "資料變更申請名冊",
                },
                name: "cadrecoop_changeroster",
                submenu: [{
                    title: {
                        CH: "返回資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            {
                title: {
                    CH: "資料變更合併送件",
                },
                name: "cadrecoop_changemerge",
                submenu: [{
                    title: {
                        CH: "返回資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            {
                title: {
                    CH: "理賠申請",
                },
                name: "cadrecoop_claim",
                submenu: [{
                    title: {
                        CH: "返回理賠申請",
                    },
                    name: "cadrecoop_claim",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "cadrecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "cadrecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "cadrecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "cadrecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "cadrecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "cadrecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "cadrecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "cadrecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "cadrecoop_claim",
                },
                ],
            },
            ],
        },
        // 儲互社員工福利團體保險
        {
            title: {
                CH: "員工福利團體保險",
            },
            name: "employeecoop",
            submenu: [{
                title: {
                    CH: "基本資料",
                },
                name: "employeecoop",
            },
            {
                title: {
                    CH: "相關文件",
                },
                name: "employeecoop_paper",
            },
            {
                title: {
                    CH: "執行中名冊",
                },
                name: "employeecoop_executiveroster",
                submenu: [{
                    title: {
                        CH: "返回執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "加保申請名冊",
                },
                name: "employeecoop_plusroster",
                submenu: [{
                    title: {
                        CH: "返回加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "退保申請名冊",
                },
                name: "employeecoop_surrenderroster",
                submenu: [{
                    title: {
                        CH: "返回退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "加退保合併送件",
                },
                name: "employeecoop_merge",
                submenu: [{
                    title: {
                        CH: "返回加退保合併送件",
                    },
                    name: "employeecoop_merge",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "資料變更申請名冊",
                },
                name: "employeecoop_changeroster",
                submenu: [{
                    title: {
                        CH: "返回資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "資料變更合併送件",
                },
                name: "employeecoop_changemerge",
                submenu: [{
                    title: {
                        CH: "返回資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "理賠申請",
                },
                name: "employeecoop_claim",
                submenu: [{
                    title: {
                        CH: "返回理賠申請",
                    },
                    name: "employeecoop_claim",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            {
                title: {
                    CH: "帳務處理",
                },
                name: "employeecoop_accounting",
                submenu: [{
                    title: {
                        CH: "返回帳務處理",
                    },
                    name: "employeecoop_accounting",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "employeecoop",
                },
                {
                    title: {
                        CH: "相關文件",
                    },
                    name: "employeecoop_paper",
                },
                {
                    title: {
                        CH: "執行中名冊",
                    },
                    name: "employeecoop_executiveroster",
                },
                {
                    title: {
                        CH: "加保申請名冊",
                    },
                    name: "employeecoop_plusroster",
                },
                {
                    title: {
                        CH: "退保申請名冊",
                    },
                    name: "employeecoop_surrenderroster",
                },
                {
                    title: {
                        CH: "加退保合併送件",
                    },
                    name: "employeecoop_merge",
                },
                {
                    title: {
                        CH: "資料變更申請名冊",
                    },
                    name: "employeecoop_changeroster",
                },
                {
                    title: {
                        CH: "資料變更合併送件",
                    },
                    name: "employeecoop_changemerge",
                },
                {
                    title: {
                        CH: "理賠申請",
                    },
                    name: "employeecoop_claim",
                },
                {
                    title: {
                        CH: "帳務處理",
                    },
                    name: "employeecoop_accounting",
                },
                ],
            },
            ],
        },
        {
            title: {
                CH: "六年平儲",
            },
            name: "",
            children: [{
                title: {
                    CH: "基本資料",
                },
                name: "six_year",
            },
            {
                title: {
                    CH: "到期查詢",
                },
                name: "six_year_maturity",
            },
            {
                title: {
                    CH: "解約",
                },
                name: "coop_six_year_release",
            },
            {
                title: {
                    CH: "月名冊",
                },
                name: "six_year_roster",
            },
            {
                title: {
                    CH: "申報表",
                },
                name: "six_year_declare",
            },
            {
                title: {
                    CH: "核對表",
                },
                name: "six_year_check",
            },
            {
                title: {
                    CH: "未按期繳納名單",
                },
                name: "six_year_unpaid",
            },
            ],
        },
        ],
    },
    {
        title: {
            CH: "放款作業",
        },
        name: "loan",
        children: [{
            title: {
                CH: "放款方案設定",
            },
            name: "loan_plan",
            submenu: [{
                title: {
                    CH: "返回放款方案設定",
                },
                name: "loan_plan",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "方案設定",
                },
                name: "loan_plan_edit",
                editshow: true,
            },
            {
                title: {
                    CH: "繳交文件設定",
                },
                name: "loan_plan_document",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回繳交文件設定",
                    },
                    name: "loan_plan_document",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "方案設定",
                    },
                    name: "loan_plan_edit",
                },
                {
                    title: {
                        CH: "繳交文件設定",
                    },
                    name: "loan_plan_document",
                },
                {
                    title: {
                        CH: "申請件",
                    },
                    name: "loan_plan_application",
                },
                {
                    title: {
                        CH: "貸後管理",
                    },
                    name: "loan_plan_manage",
                },
                {
                    title: {
                        CH: "利率調整",
                    },
                    name: "loan_plan_rate",
                },
                ],
            },
            {
                title: {
                    CH: "申請件",
                },
                name: "loan_plan_application",
                editshow: true,
            },
            {
                title: {
                    CH: "貸後管理",
                },
                name: "loan_plan_manage",
                editshow: true,
            },
            {
                title: {
                    CH: "利率調整",
                },
                name: "loan_plan_rate",
                editshow: true,
            },
            ],
        },
        {
            title: {
                CH: "放款申請管理",
            },
            name: "loan_application",
        },
        {
            title: {
                CH: "還款試算表",
            },
            name: "repayment_balance",
        },
        {
            title: {
                CH: "放款應收利息試算表",
            },
            name: "lending_interest_receivable",
        },
        {
            title: {
                CH: "未取款借據",
            },
            name: "unwithdrawn_debit",
        },
        {
            title: {
                CH: "借據管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "執行中",
                },
                name: "after_loan",
                query: "getRunningIou",
                submenu: [{
                    title: {
                        CH: "返回借據管理",
                    },
                    name: "after_loan",
                    query: "getRunningIou",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "檢視借據",
                    },
                    name: "after_loan_edit",
                },
                {
                    title: {
                        CH: "借據還款試算",
                    },
                    name: "after_loan_trialcalc",
                },
                {
                    title: {
                        CH: "借據違約試算",
                    },
                    name: "after_loan_breachcalc",
                },
                {
                    title: {
                        CH: "相關文件管理",
                    },
                    name: "after_loan_doc",
                },
                {
                    title: {
                        CH: "擔保品管理",
                    },
                    name: "after_loan_collateral",
                    submenu: [{
                        title: {
                            CH: "返回擔保品管理",
                        },
                        name: "after_loan_collateral",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "檢視借據",
                        },
                        name: "after_loan_edit",
                    },
                    {
                        title: {
                            CH: "借據還款試算",
                        },
                        name: "after_loan_trialcalc",
                    },
                    {
                        title: {
                            CH: "借據違約試算",
                        },
                        name: "after_loan_breachcalc",
                    },
                    {
                        title: {
                            CH: "相關文件管理",
                        },
                        name: "after_loan_doc",
                    },
                    {
                        title: {
                            CH: "擔保品管理",
                        },
                        name: "after_loan_collateral",
                    },
                    {
                        title: {
                            CH: "延期協議設定",
                        },
                        name: "after_loan_extension",
                    },
                    {
                        title: {
                            CH: "逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                    },
                    {
                        title: {
                            CH: "還款紀錄",
                        },
                        name: "after_loan_record",
                        query: "repayment",
                    },
                    {
                        title: {
                            CH: "取款紀錄",
                        },
                        name: "after_loan_record",
                        query: "withdrawal",
                    },
                    {
                        title: {
                            CH: "電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                    },
                    {
                        title: {
                            CH: "書面催收工作管理",
                        },
                        name: "after_loan_written",
                    },
                    {
                        title: {
                            CH: "法律催收工作管理",
                        },
                        name: "after_loan_legal",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷作業",
                        },
                        name: "after_loan_badloan",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷後收回作業",
                        },
                        name: "after_loan_badloanreturn",
                    },
                    ],
                },
                {
                    title: {
                        CH: "延期協議設定",
                    },
                    name: "after_loan_extension",
                    submenu: [{
                        title: {
                            CH: "返回延期協議設定",
                        },
                        name: "after_loan_extension",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "檢視借據",
                        },
                        name: "after_loan_edit",
                    },
                    {
                        title: {
                            CH: "借據還款試算",
                        },
                        name: "after_loan_trialcalc",
                    },
                    {
                        title: {
                            CH: "借據違約試算",
                        },
                        name: "after_loan_breachcalc",
                    },
                    {
                        title: {
                            CH: "相關文件管理",
                        },
                        name: "after_loan_doc",
                    },
                    {
                        title: {
                            CH: "擔保品管理",
                        },
                        name: "after_loan_collateral",
                    },
                    {
                        title: {
                            CH: "延期協議設定",
                        },
                        name: "after_loan_extension",
                    },
                    {
                        title: {
                            CH: "逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                    },
                    {
                        title: {
                            CH: "還款紀錄",
                        },
                        name: "after_loan_record",
                        query: "repayment",
                    },
                    {
                        title: {
                            CH: "取款紀錄",
                        },
                        name: "after_loan_record",
                        query: "withdrawal",
                    },
                    {
                        title: {
                            CH: "電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                    },
                    {
                        title: {
                            CH: "書面催收工作管理",
                        },
                        name: "after_loan_written",
                    },
                    {
                        title: {
                            CH: "法律催收工作管理",
                        },
                        name: "after_loan_legal",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷作業",
                        },
                        name: "after_loan_badloan",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷後收回作業",
                        },
                        name: "after_loan_badloanreturn",
                    },
                    ],
                },
                {
                    title: {
                        CH: "逾期約定償還協議",
                    },
                    name: "after_loan_overdue",
                    submenu: [{
                        title: {
                            CH: "返回逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "檢視借據",
                        },
                        name: "after_loan_edit",
                    },
                    {
                        title: {
                            CH: "借據還款試算",
                        },
                        name: "after_loan_trialcalc",
                    },
                    {
                        title: {
                            CH: "借據違約試算",
                        },
                        name: "after_loan_breachcalc",
                    },
                    {
                        title: {
                            CH: "相關文件管理",
                        },
                        name: "after_loan_doc",
                    },
                    {
                        title: {
                            CH: "擔保品管理",
                        },
                        name: "after_loan_collateral",
                    },
                    {
                        title: {
                            CH: "延期協議設定",
                        },
                        name: "after_loan_extension",
                    },
                    {
                        title: {
                            CH: "逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                    },
                    {
                        title: {
                            CH: "還款紀錄",
                        },
                        name: "after_loan_record",
                        query: "repayment",
                    },
                    {
                        title: {
                            CH: "取款紀錄",
                        },
                        name: "after_loan_record",
                        query: "withdrawal",
                    },
                    {
                        title: {
                            CH: "電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                    },
                    {
                        title: {
                            CH: "書面催收工作管理",
                        },
                        name: "after_loan_written",
                    },
                    {
                        title: {
                            CH: "法律催收工作管理",
                        },
                        name: "after_loan_legal",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷作業",
                        },
                        name: "after_loan_badloan",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷後收回作業",
                        },
                        name: "after_loan_badloanreturn",
                    },
                    ],
                },
                {
                    title: {
                        CH: "還款紀錄",
                    },
                    name: "after_loan_record",
                    query: "repayment",
                },
                {
                    title: {
                        CH: "取款紀錄",
                    },
                    name: "after_loan_record",
                    query: "withdrawal",
                },
                {
                    title: {
                        CH: "電話催收工作管理",
                    },
                    name: "after_loan_telephone",
                    submenu: [{
                        title: {
                            CH: "返回電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "檢視借據",
                        },
                        name: "after_loan_edit",
                    },
                    {
                        title: {
                            CH: "借據還款試算",
                        },
                        name: "after_loan_trialcalc",
                    },
                    {
                        title: {
                            CH: "借據違約試算",
                        },
                        name: "after_loan_breachcalc",
                    },
                    {
                        title: {
                            CH: "相關文件管理",
                        },
                        name: "after_loan_doc",
                    },
                    {
                        title: {
                            CH: "擔保品管理",
                        },
                        name: "after_loan_collateral",
                    },
                    {
                        title: {
                            CH: "延期協議設定",
                        },
                        name: "after_loan_extension",
                    },
                    {
                        title: {
                            CH: "逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                    },
                    {
                        title: {
                            CH: "還款紀錄",
                        },
                        name: "after_loan_record",
                        query: "repayment",
                    },
                    {
                        title: {
                            CH: "取款紀錄",
                        },
                        name: "after_loan_record",
                        query: "withdrawal",
                    },
                    {
                        title: {
                            CH: "電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                    },
                    {
                        title: {
                            CH: "書面催收工作管理",
                        },
                        name: "after_loan_written",
                    },
                    {
                        title: {
                            CH: "法律催收工作管理",
                        },
                        name: "after_loan_legal",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷作業",
                        },
                        name: "after_loan_badloan",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷後收回作業",
                        },
                        name: "after_loan_badloanreturn",
                    },
                    ],
                },
                {
                    title: {
                        CH: "書面催收工作管理",
                    },
                    name: "after_loan_written",
                    submenu: [{
                        title: {
                            CH: "返回書面催收工作管理",
                        },
                        name: "after_loan_written",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "檢視借據",
                        },
                        name: "after_loan_edit",
                    },
                    {
                        title: {
                            CH: "借據還款試算",
                        },
                        name: "after_loan_trialcalc",
                    },
                    {
                        title: {
                            CH: "借據違約試算",
                        },
                        name: "after_loan_breachcalc",
                    },
                    {
                        title: {
                            CH: "相關文件管理",
                        },
                        name: "after_loan_doc",
                    },
                    {
                        title: {
                            CH: "擔保品管理",
                        },
                        name: "after_loan_collateral",
                    },
                    {
                        title: {
                            CH: "延期協議設定",
                        },
                        name: "after_loan_extension",
                    },
                    {
                        title: {
                            CH: "逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                    },
                    {
                        title: {
                            CH: "還款紀錄",
                        },
                        name: "after_loan_record",
                        query: "repayment",
                    },
                    {
                        title: {
                            CH: "取款紀錄",
                        },
                        name: "after_loan_record",
                        query: "withdrawal",
                    },
                    {
                        title: {
                            CH: "電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                    },
                    {
                        title: {
                            CH: "書面催收工作管理",
                        },
                        name: "after_loan_written",
                    },
                    {
                        title: {
                            CH: "法律催收工作管理",
                        },
                        name: "after_loan_legal",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷作業",
                        },
                        name: "after_loan_badloan",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷後收回作業",
                        },
                        name: "after_loan_badloanreturn",
                    },
                    ],
                },
                {
                    title: {
                        CH: "法律催收工作管理",
                    },
                    name: "after_loan_legal",
                    submenu: [{
                        title: {
                            CH: "返回法律催收工作管理",
                        },
                        name: "after_loan_legal",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "檢視借據",
                        },
                        name: "after_loan_edit",
                    },
                    {
                        title: {
                            CH: "借據還款試算",
                        },
                        name: "after_loan_trialcalc",
                    },
                    {
                        title: {
                            CH: "借據違約試算",
                        },
                        name: "after_loan_breachcalc",
                    },
                    {
                        title: {
                            CH: "相關文件管理",
                        },
                        name: "after_loan_doc",
                    },
                    {
                        title: {
                            CH: "擔保品管理",
                        },
                        name: "after_loan_collateral",
                    },
                    {
                        title: {
                            CH: "延期協議設定",
                        },
                        name: "after_loan_extension",
                    },
                    {
                        title: {
                            CH: "逾期約定償還協議",
                        },
                        name: "after_loan_overdue",
                    },
                    {
                        title: {
                            CH: "還款紀錄",
                        },
                        name: "after_loan_record",
                        query: "repayment",
                    },
                    {
                        title: {
                            CH: "取款紀錄",
                        },
                        name: "after_loan_record",
                        query: "withdrawal",
                    },
                    {
                        title: {
                            CH: "電話催收工作管理",
                        },
                        name: "after_loan_telephone",
                    },
                    {
                        title: {
                            CH: "書面催收工作管理",
                        },
                        name: "after_loan_written",
                    },
                    {
                        title: {
                            CH: "法律催收工作管理",
                        },
                        name: "after_loan_legal",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷作業",
                        },
                        name: "after_loan_badloan",
                    },
                    {
                        title: {
                            CH: "呆帳轉銷後收回作業",
                        },
                        name: "after_loan_badloanreturn",
                    },
                    ],
                },
                {
                    title: {
                        CH: "呆帳轉銷作業",
                    },
                    name: "after_loan_badloan",
                },
                {
                    title: {
                        CH: "呆帳轉銷後收回作業",
                    },
                    name: "after_loan_badloanreturn",
                },
                ],
            },
            {
                title: {
                    CH: "已違約",
                },
                name: "after_loan",
                query: "getBreakIou",
            },
            {
                title: {
                    CH: "已結清",
                },
                name: "after_loan",
                query: "getFinishIou",
            },
            {
                title: {
                    CH: "已失效",
                },
                name: "after_loan",
                query: "getCancelIou",
            },
            ],
        },
        {
            title: {
                CH: "借款條件異動處理",
            },
            name: "loan_plan_change",
        },
        ],
    },
    {
        title: {
            CH: "審核作業",
        },
        name: "coop_review",
        children: [{
            title: {
                CH: "審核作業",
            },
            name: "coop_review",
            children: [{
                title: {
                    CH: "傳票審核",
                },
                name: "coop_review_voucher_list",
            },
            {
                title: {
                    CH: "其他審核",
                },
                name: "coop_review_other_list",
            },
            ],
        },
        {
            title: {
                CH: "歷史審查列表",
            },
            name: "coop_review_history_list",
        },
        ],
    },
    {
        title: {
            CH: "會計作業",
        },
        name: "coop_account",
        children: [{
            title: {
                CH: "傳票確認作業",
            },
            name: "subpoena_confirm",
        },
        {
            title: {
                CH: "傳票管理",
            },
            name: "",
            children: [{
                title: {
                    CH: "傳票管理",
                },
                name: "coop_summons",
            },
            {
                title: {
                    CH: "錯誤更正傳票管理",
                },
                name: "ec_coop_summons",
            },
            {
                title: {
                    CH: "各科目總和傳票",
                },
                name: "total_summons",
            },
            {
                title: {
                    CH: "委託轉帳總和傳票",
                },
                name: "transfer_total_summons",
            },
            {
                title: {
                    CH: "收款單管理",
                },
                name: "coop_receipt",
            },
            {
                title: {
                    CH: "支出轉帳傳票管理",
                },
                name: "expense_summons",
            },
            ],
        },
        {
            title: {
                CH: "收款日計表",
            },
            name: "income_daily",
        },
        {
            title: {
                CH: "收支日計表",
            },
            name: "income_expenditure_daily",
        },
        {
            title: {
                CH: "會計科目分類帳",
            },
            name: "account_subject",
        },
        {
            title: {
                CH: "社員薪資轉帳作業",
            },
            name: "member_salary",
        },
        {
            title: {
                CH: "薪資轉帳個人扣款明細單",
            },
            name: "transfer_detail",
        },
        {
            title: {
                CH: "職員薪資計算作業",
            },
            name: "staff_salary",
        },
        {
            title: {
                CH: "職員薪資項目設定",
            },
            name: "staff_salary_project",
        },
        {
            title: {
                CH: "委託轉帳作業",
            },
            name: "entrusted_transfer",
            submenu: [{
                title: {
                    CH: "返回委託轉帳作業",
                },
                name: "entrusted_transfer",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "entrusted_transfer_edit",
            },
            {
                title: {
                    CH: "相關傳票",
                },
                name: "entrusted_transfer_summons",
                editshow: true,
                submenu: [{
                    title: {
                        CH: "返回委託轉帳作業",
                    },
                    name: "entrusted_transfer",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本資料",
                    },
                    name: "entrusted_transfer_edit",
                },
                {
                    title: {
                        CH: "相關傳票",
                    },
                    name: "entrusted_transfer_summons",
                },
                ],
            },
            ],
        },
        {
            title: {
                CH: "委託轉帳處理結果",
            },
            name: "entrusted_transfer_result",
        },
        {
            title: {
                CH: "特定轉帳作業",
            },
            name: "",
            children: [{
                title: {
                    CH: "特定轉帳作業",
                },
                name: "specific_transfer",
                submenu: [{
                    title: {
                        CH: "返回特定轉帳作業",
                    },
                    name: "specific_transfer",
                    icon: "fa-chevron-left",
                },
                {
                    title: {
                        CH: "基本設定",
                    },
                    name: "specific_transfer_edit",
                },
                {
                    title: {
                        CH: "特定轉帳明細",
                    },
                    name: "specific_transfer_detial",
                    editshow: true,
                    submenu: [{
                        title: {
                            CH: "返回特定轉帳明細",
                        },
                        name: "specific_transfer_detial",
                        icon: "fa-chevron-left",
                    },
                    {
                        title: {
                            CH: "基本設定",
                        },
                        name: "specific_transfer_edit",
                    },
                    {
                        title: {
                            CH: "特定轉帳明細",
                        },
                        name: "specific_transfer_detial",
                    },
                    {
                        title: {
                            CH: "傳票紀錄",
                        },
                        name: "specific_transfer_log",
                    },
                    ],
                },
                {
                    editshow: true,
                    title: {
                        CH: "傳票紀錄",
                    },
                    name: "specific_transfer_log",
                },
                ],
            },
            {
                title: {
                    CH: "特定轉帳作業處理",
                },
                name: "specific_transfer_processing",
            },
            ],
        },

        {
            title: {
                CH: "日結作業",
            },
            name: "",
            children: [{
                title: {
                    CH: "日記帳",
                },
                name: "journal",
            },
            {
                title: {
                    CH: "日報表",
                },
                name: "daily_report",
            },
            {
                title: {
                    CH: "現金銀行存款日報表",
                },
                name: "cash_bank_daily_report",
            },
            ],
        },
        {
            title: {
                CH: "月結作業",
            },
            name: "",
            children: [{
                title: {
                    CH: "股金放款核對表",
                },
                name: "stock_lending",
            },
            {
                title: {
                    CH: "備轉金核對表",
                },
                name: "reserve_transfer",
            },
            {
                title: {
                    CH: "準社員核對表",
                },
                name: "quasi_member_checklist",
            },
            {
                title: {
                    CH: "財務業務統計表",
                },
                name: "financial_business",
            },
            {
                title: {
                    CH: "資產負債表",
                },
                name: "balance_sheet",
            },
            {
                title: {
                    CH: "損益表",
                },
                name: "profit_loss",
            },
            {
                title: {
                    CH: "損益表(預決算比較)",
                },
                name: "profit_loss_pre",
            },
            {
                title: {
                    CH: "放款資產評估明細表",
                },
                name: "loan_asset",
            },
            {
                title: {
                    CH: "放款資產評估分類明細表",
                },
                name: "loan_asset_classification",
            },
            {
                title: {
                    CH: "手動月結作業",
                },
                name: "manual_monthly",
            },
            ],
        },
        {
            title: {
                CH: "年結作業",
            },
            name: "",
            children: [{
                title: {
                    CH: "明細分類帳",
                },
                name: "detailed_ledger",
            },
            {
                title: {
                    CH: "總分類帳",
                },
                name: "general_ledger",
            },
            {
                title: {
                    CH: "圓股數明細表",
                },
                name: "round_number",
            },
            {
                title: {
                    CH: "放款用途統計",
                },
                name: "loan_use",
            },
            {
                title: {
                    CH: "股利攤還表",
                },
                name: "dividends",
            },
            {
                title: {
                    CH: "備轉金股息明細表",
                },
                name: "transfer_dividends",
            },
            {
                title: {
                    CH: "社員對帳單_社員",
                },
                name: "bank_statement_member",
            },
            {
                title: {
                    CH: "社員對帳單_歸戶",
                },
                name: "bank_statement_return",
            },
            {
                title: {
                    CH: "社員對帳單_協會",
                },
                name: "bank_statement_association",
            },
            {
                title: {
                    CH: "廣告回函封面",
                },
                name: "advertising_cover",
            },
            {
                title: {
                    CH: "對帳單_廣告回函用",
                },
                name: "advertising_reply",
            },
            {
                title: {
                    CH: "對帳單備註欄註記管理",
                },
                name: "annotation_remarks",
            },
            {
                title: {
                    CH: "社員年度個人帳",
                },
                name: "member_annual",
            },
            {
                title: {
                    CH: "備轉金年度個人帳",
                },
                name: "transfer_annual",
            },
            {
                title: {
                    CH: "社員年費各類明細表",
                },
                name: "annual_fee",
            },
            {
                title: {
                    CH: "歷年年結紀錄",
                },
                name: "annual_knot",
            },
            ],
        },
        {
            title: {
                CH: "年度預算管理",
            },
            name: "annual_budget",
        },
        {
            title: {
                CH: "股息扣繳媒體申報資料轉出",
            },
            name: "dividends_media",
        },
        {
            title: {
                CH: "自動傳票清單明細",
            },
            name: "",
            children: [{
                title: {
                    CH: "年結轉分錄明細",
                },
                name: "automatic_voucher",
                query: "YearEndEntry",
            },
            {
                title: {
                    CH: "委託轉帳分錄明細",
                },
                name: "automatic_voucher",
                query: "EmtrustedTransferEntry",
            },
            {
                title: {
                    CH: "準社員升社員分錄明細",
                },
                name: "automatic_voucher",
                query: "MemberToFormalEntry",
            },
            {
                title: {
                    CH: "備轉金息發放分錄明細",
                },
                name: "automatic_voucher",
                query: "TransferInterestEntry",
            },
            {
                title: {
                    CH: "股息發放分錄明細",
                },
                name: "automatic_voucher",
                query: "StockInterestEntry",
            },
            {
                title: {
                    CH: "財產折舊/報廢分錄明細",
                },
                name: "automatic_voucher",
                query: "DepreciationEntry",
            },
            {
                title: {
                    CH: "特定轉帳分錄明細",
                },
                name: "automatic_voucher",
                query: "SpecificTransferEntry",
            },
            {
                title: {
                    CH: "六年平儲生效分錄明細",
                },
                name: "automatic_voucher",
                query: "InsSavingApplyEntry",
            },
            {
                title: {
                    CH: "安基代辦分錄明細",
                },
                name: "ins_plan_entry",
            },
            ],
        },
        {
            title: {
                CH: "雜誌訂閱資料",
            },
            name: "magzin",
        },
        ],
    },
    {
        title: {
            CH: "出納作業",
        },
        name: "cashier",
        children: [{
            title: {
                CH: "銀行交易明細管理",
            },
            name: "bank_transaction",
        },
        {
            title: {
                CH: "財產清冊管理",
            },
            name: "property",
            submenu: [{
                title: {
                    CH: "返回財產清冊管理",
                },
                name: "property",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "property_edit",
            },
            {
                title: {
                    CH: "相關傳票",
                },
                name: "property_summons",
                editshow: true,
            },
            ],
        },
        {
            title: {
                CH: "財產報廢管理",
            },
            name: "retire_property",
            submenu: [{
                title: {
                    CH: "返回財產報廢管理",
                },
                name: "retire_property",
                icon: "fa-chevron-left",
            },
            {
                title: {
                    CH: "基本資料",
                },
                name: "retire_property_edit",
            },
            {
                title: {
                    CH: "相關傳票",
                },
                name: "retire_property_summons",
                editshow: true,
            },
            ],
        },
        ],
    },
    {
        title: {
            CH: "日結作業",
        },
        name: "daily",
        children: [{
            title: {
                CH: "日結作業",
            },
            children: [{
                title: {
                    CH: "日結作業_主管",
                },
                name: "daily_supervisor",
            },
            {
                title: {
                    CH: "日結作業_臨櫃",
                },
                name: "daily_cabinet",
            },
            {
                title: {
                    CH: "日結作業_出納",
                },
                name: "daily_cashier",
            },
            {
                title: {
                    CH: "日結作業_會計",
                },
                name: "daily_account",
            },
            ],
        },],
    },
    {
        title: {
            CH: "請款作業",
        },
        name: "request",
        children: [{
            title: {
                CH: "未開立傳票",
            },
            name: "unopened_account",
        },
        {
            title: {
                CH: "已開立傳票",
            },
            name: "opened_account",
        },
        {
            title: {
                CH: "未上傳水單",
            },
            name: "not_uploaded",
        },
        {
            title: {
                CH: "已上傳水單",
            },
            name: "uploaded_cashier",
        },
        {
            title: {
                CH: "全部請款單管理",
            },
            name: "all_payment",
        },
        ],
    },
    ],
};

export {
    systemMenu
};